import { render, staticRenderFns } from "./exhibition-activity-add.vue?vue&type=template&id=8c4d6abc&scoped=true&"
import script from "./exhibition-activity-add.vue?vue&type=script&lang=js&"
export * from "./exhibition-activity-add.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-activity-add.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./exhibition-activity-add.vue?vue&type=style&index=1&id=8c4d6abc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4d6abc",
  null
  
)

export default component.exports